import script from "./WalletButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletButtons.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__